

export const keys = {
    all: ["tank-style-data"],

    tankStyles: () => [
        ...keys.all,
        "tank-styles"
    ],

};